import { StartMeetingRequest, StartMeetingResponse } from '@eigtech/meetings-types'
import { contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { meetingsBasePath } from './constants'

const startMeeting = ({ entityId, cohort, ...body }: Omit<StartMeetingRequest, 'requestActor'>) =>
  contextualPost<StartMeetingResponse>(
    `${meetingsBasePath}/meeting/create/${entityId}/${cohort}`,
    body
  )

// start meeting
export const useStartMeeting = () =>
  useMutation({
    mutationFn: startMeeting,
  })
